"use client";

import { IconButton, type IconButtonProps } from "@chakra-ui/react";

const shareIconButtonStyles = {
  size: "sm" as const,
  rounded: "full" as const,
  bg: "whiteAlpha.100",
  color: "neutral.200",
  _hover: { bg: "whiteAlpha.200", shadow: "shadow-primary-xl" },
};

export type ShareIconButtonProps = IconButtonProps;

export function ShareIconButton({ children, ...props }: ShareIconButtonProps) {
  return (
    <IconButton {...shareIconButtonStyles} {...props}>
      {children}
    </IconButton>
  );
}
